// import React from 'react';
// import Colors from './Colors';
// import { pdfLink } from './Strings';
// import { MdEdit, MdDelete, MdOutlinePendingActions } from "react-icons/md";
// import { HiArrowCircleDown } from "react-icons/hi";
// import { IoIosPrint } from "react-icons/io";
// const SalesCard = ({ location, data, invoices, starttime, endtime, tab }) => {
//   const { sales, pending, received } = data;
//   const handlePrintLoad = (invoiceId) => {
//     const url = `${pdfLink}/loadsheet.php?invoice_id=${invoiceId}`;
//     window.open(url, "_blank");
//   };
//     const handleWithPending = (invoiceId, customerId) => {
//       const pending = true;
//       const url = `${pdfLink}/printInvoice.php?invoice_id=${invoiceId}&customer_Id=${customerId}&with_pending=${pending}`;
//       window.open(url, "_blank");
//     };
//   const handlePrint = async () => {
//     const queryParams = new URLSearchParams({
//       location,
//       starttime: starttime || '',
//       endtime: endtime || '',
//       tab,
//     });

//     const url = `${pdfLink}/generateSalesReport.php?${queryParams.toString()}`;
//     window.open(url, '_blank');
//   };

//   const handleInvoiceAction = (invoiceId,customerId) => {
//       const url = `${pdfLink}/printInvoice.php?invoice_id=${invoiceId}&customer_Id=${customerId}`;
//       window.open(url, "_blank");
//   };

//   return (
//     <div
//       style={{
//         background: "#fff",
//         borderRadius: "12px",
//         boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
//         padding: "20px",
//         maxWidth: "800px",
//         margin: "20px auto",
//         fontFamily: "Segoe UI, Arial, sans-serif",
//         color: "#333",
//       }}
//     >
//       <h3 style={{ marginBottom: "15px", fontSize: "22px", fontWeight: "600" }}>
//         {location}
//       </h3>

//       <button
//         style={{
//           width: "100%",
//           padding: "12px",
//           border: "none",
//           background: "#007bff",
//           color: "white",
//           borderRadius: "8px",
//           cursor: "pointer",
//           fontWeight: "bold",
//           marginBottom: "20px",
//           fontSize: "16px",
//           transition: "0.3s ease",
//         }}
//         onClick={handlePrint}
//         onMouseOver={(e) => (e.currentTarget.style.background = "#0056b3")}
//         onMouseOut={(e) => (e.currentTarget.style.background = "#007bff")}
//       >
//         Print
//       </button>

//       <div style={{ marginBottom: "20px" }}>
//         <p>
//           <strong>Total Sales:</strong> {sales}
//         </p>
//         <p>
//           <strong>Total Pending:</strong> {pending}
//         </p>
//         <p>
//           <strong>Total Received:</strong> {received}
//         </p>
//       </div>

//       <h4 style={{ marginBottom: "10px", fontSize: "18px", fontWeight: "600" }}>
//         Invoice Details:
//       </h4>

//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
//           gap: "15px",
//           maxHeight: "400px",
//           overflowY: "auto",
//           paddingRight: "5px",
//         }}
//       >
//         {invoices.length > 0 ? (
//           invoices.map((invoice) => (
//             <div
//               key={invoice.id}
//               style={{
//                 background: "#E0DEDE",
//                 border: "1px solid #e0e0e0",
//                 borderRadius: "10px",
//                 padding: "15px",
//                 boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "space-between",
//               }}
//             >
//               <div style={{ fontSize: "14px", marginBottom: "10px" }}>
//                 <p><strong>Invoice ID:</strong> {invoice.id}</p>
//                 <p><strong>Customer:</strong> {invoice.customer_name}</p>
//                 <p><strong>Pending:</strong> {invoice.pending}</p>
//                 <p><strong>Received:</strong> {invoice.received}</p>
//               </div>
//               <div className="button-group">
//                                 <button
//                                   onClick={() => handleWithPending(invoice.id, invoice.customer_id)}
//                                   className="action-btn black"
//                                 >
//                                   <MdOutlinePendingActions /> <span>With Pending</span>
//                                 </button>
              
//                                 <button
//                                   onClick={() => handlePrintLoad(invoice.id)}
//                                   className="action-btn primary"
//                                 >
//                                   <HiArrowCircleDown /> <span>Load Sheet</span>
//                                 </button>
              
//                                 <button
//                                   onClick={() => handlePrint(invoice.id, invoice.customer_id)}
//                                   className="action-btn primary"
//                                 >
//                                   <IoIosPrint /> <span>Print</span>
//                                 </button>
//                                 </div>
//             </div>
//           ))
//         ) : (
//           <p style={{ textAlign: "center", color: "#777" }}>
//             No invoices found.
//           </p>
//         )}
//       </div>
//       <>
//       {/* Inline CSS */}
//       <style>
//         {`
//           .tabs {
//             display: flex;
//             gap: 10px;
//             margin-bottom: 20px;
//             flex-wrap: wrap;
//           }

//           .tab {
//             padding: 10px 15px;
//             border-radius: 6px;
//             border: 1px solid #ccc;
//             background: #f7f7f7;
//             cursor: pointer;
//             transition: all 0.2s ease-in-out;
//           }

//           .tab:hover {
//             background: #eee;
//           }

//           .tab.active {
//             background: ${Colors.primary};
//             color: white;
//             border-color: ${Colors.primary};
//           }

//           .card-content {
//             display: flex;
//             justify-content: space-between;
//             align-items: flex-start;
//             flex-wrap: wrap;
//           }

//           .bill-info {
//             flex: 1;
//             min-width: 250px;
//           }

//           .button-group {
//             display: flex;
//             gap: 10px;
//             flex-wrap: wrap;
//             justify-content: flex-end;
//             align-items: center;
//             background: #E0DEDE;
//             padding:12px;
//           }

//           .action-btn {
//             display: flex;
//             align-items: center;
//             gap: 5px;
//             font-size: 14px;
//             padding: 8px 12px;
//             border-radius: 6px;
//             border: none;
//             cursor: pointer;
//             background: #f7f7f7;
//             box-shadow: 0 1px 3px rgba(0,0,0,0.1);
//             transition: all 0.2s ease-in-out;
//           }

//           .action-btn:hover {
//             transform: translateY(-2px);
//             box-shadow: 0 4px 8px rgba(0,0,0,0.15);
//           }

//           .action-btn.primary { color: ${Colors.primary}; }
//           .action-btn.green { color: green; }
//           .action-btn.red { color: red; }
//           .action-btn.black { color: black; }

//           @media (max-width: 768px) {
//             .card-content {
//               flex-direction: column;
//               align-items: flex-start;
//             }
//             .button-group {
//               width: 100%;
//               justify-content: flex-start;
//               flex-direction: column;
//               margin-top: 15px;
//             }
//             .action-btn {
//               width: 100%;
//               justify-content: flex-start;
//             }
//           }
//         `}
//       </style></>
//     </div>
    
//   );
// };

// export default SalesCard;
import React, { useState } from "react";
import Colors from "./Colors";
import { pdfLink } from "./Strings";

const SalesCard = ({ location, data, invoices, starttime, endtime, tab }) => {
  const { sales, pending, received } = data;
  const [selectedInvoices, setSelectedInvoices] = useState([]);

  const toggleInvoiceSelection = (invoiceId) => {
    setSelectedInvoices((prev) =>
      prev.includes(invoiceId)
        ? prev.filter((id) => id !== invoiceId)
        : [...prev, invoiceId]
    );
  };

  // Bulk Actions
  const handleBulkLoadsheet = () => {
    if (selectedInvoices.length === 0) return;
    const ids = selectedInvoices.join(",");
    const url = `${pdfLink}/loadsheetBulk.php?ids=${ids}`;
    window.open(url, "_blank");
  };

  const handleBulkWithPending = () => {
    if (selectedInvoices.length === 0) return;
    const ids = selectedInvoices.join(",");
    const url = `${pdfLink}/printInvoicesBulk.php?ids=${ids}`;
    window.open(url, "_blank");
  };

  const handleBulkPrint = () => {
    if (selectedInvoices.length === 0) return;
    const ids = selectedInvoices.join(",");
    const url = `${pdfLink}/printInvoicesBulk.php?ids=${ids}`;
    window.open(url, "_blank");
  };

  const handlePrint = async () => {
    const queryParams = new URLSearchParams({
      location,
      starttime: starttime || "",
      endtime: endtime || "",
      tab,
    });

    const url = `${pdfLink}/generateSalesReport.php?${queryParams.toString()}`;
    window.open(url, "_blank");
  };

    const handlePrintBulk = async () => {
    if (selectedInvoices.length === 0) return;
    const ids = selectedInvoices.join(",");

    const url = `${pdfLink}/generatesalereportwithid.php?invoice_ids=${ids}`;
    window.open(url, "_blank");
  };


  return (
    <div
      style={{
        background: "#fff",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        padding: "20px",
        maxWidth: "800px",
        margin: "20px auto",
        fontFamily: "Segoe UI, Arial, sans-serif",
        color: "#333",
      }}
    >
      <h3 style={{ marginBottom: "15px", fontSize: "22px", fontWeight: "600" }}>
        {location}
      </h3>

      {/* Sales Report Print Button */}
      <button
        style={{
          width: "100%",
          padding: "12px",
          border: "none",
          background: "#007bff",
          color: "white",
          borderRadius: "8px",
          cursor: "pointer",
          fontWeight: "bold",
          marginBottom: "20px",
          fontSize: "16px",
          transition: "0.3s ease",
        }}
        onClick={handlePrint}
        onMouseOver={(e) => (e.currentTarget.style.background = "#0056b3")}
        onMouseOut={(e) => (e.currentTarget.style.background = "#007bff")}
      >
        Print Sales Report
      </button>

      {/* Bulk Action Buttons */}
      {selectedInvoices.length > 0 && (
        <div style={{ display: "flex", gap: "10px", marginBottom: "20px" }}>
          <button className="bulk-btn" onClick={handlePrintBulk}>
            Sale report
          </button>
          <button className="bulk-btn" onClick={handleBulkLoadsheet}>
            Loadsheet
          </button>
          <button className="bulk-btn" onClick={handleBulkPrint}>
            Invoices Print
          </button>
        </div>
      )}

      <div style={{ marginBottom: "20px" }}>
        <p>
          <strong>Total Sales:</strong> {sales}
        </p>
        <p>
          <strong>Total Pending:</strong> {pending}
        </p>
        <p>
          <strong>Total Received:</strong> {received}
        </p>
      </div>

      <h4 style={{ marginBottom: "10px", fontSize: "18px", fontWeight: "600" }}>
        Invoice Details:
      </h4>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: "15px",
          maxHeight: "400px",
          overflowY: "auto",
          paddingRight: "5px",
        }}
      >
        {invoices.length > 0 ? (
          invoices.map((invoice) => (
            <div
              key={invoice.id}
              style={{
                position: "relative",
                background: "#E0DEDE",
                border: "1px solid #e0e0e0",
                borderRadius: "10px",
                padding: "15px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              {/* Checkbox in corner */}
              <input
                type="checkbox"
                checked={selectedInvoices.includes(invoice.id)}
                onChange={() => toggleInvoiceSelection(invoice.id)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  transform: "scale(1.3)",
                  cursor: "pointer",
                }}
              />

              <div style={{ fontSize: "14px", marginBottom: "10px" }}>
                <p>
                  <strong>Invoice ID:</strong> {invoice.id}
                </p>
                <p>
                  <strong>Customer:</strong> {invoice.customer_name}
                </p>
                <p>
                  <strong>Pending:</strong> {invoice.pending}
                </p>
                <p>
                  <strong>Received:</strong> {invoice.received}
                </p>
              </div>

              {/* old individual buttons commented out */}
              {/*
              <div className="button-group">
                <button onClick={() => handleWithPending(invoice.id, invoice.customer_id)} className="action-btn black">
                  With Pending
                </button>
                <button onClick={() => handlePrintLoad(invoice.id)} className="action-btn primary">
                  Load Sheet
                </button>
                <button onClick={() => handleInvoiceAction(invoice.id, invoice.customer_id)} className="action-btn primary">
                  Print
                </button>
              </div>
              */}
            </div>
          ))
        ) : (
          <p style={{ textAlign: "center", color: "#777" }}>
            No invoices found.
          </p>
        )}
      </div>

      {/* Inline CSS for new bulk buttons */}
      <style>
        {`
          .bulk-btn {
            flex: 1;
            padding: 10px 15px;
            background: ${Colors.primary};
            color: white;
            border: none;
            border-radius: 6px;
            cursor: pointer;
            font-weight: 600;
            transition: 0.2s ease-in-out;
          }
          .bulk-btn:hover {
            background: #0056b3;
          }
        `}
      </style>
    </div>
  );
};

export default SalesCard;

